import { combineReducers } from 'redux';

import rootCausesReducer from './ducks/root-causes';
import commonReducer from './ducks/common';
import rdcReducer from './ducks/rdc';
import vdcReducer from './ducks/vdc';

export default combineReducers({
  rootCauses: rootCausesReducer,
  common: commonReducer,
  rdc: rdcReducer,
  vdc: vdcReducer,
});
